<template>
  <div class="container py-5 text-center">
    <div v-if="status === 'loading'">
      <p>결제를 확인하는 중입니다...</p>
    </div>
    <div v-else-if="status === 'success'">
      <p class="fwb" style="font-size: 18px;">결제가 완료되었습니다.</p>
      <button class="btn btn_md btn_brown mt20" @click="$router.push('/mypage/PrescriptionList')">
        처방 내역으로 이동
      </button>
    </div>
    <div v-else-if="status === 'virtual_account'">
      <p class="fwb" style="font-size: 18px;">
        {{ paymentType === 'DR' ? '적립금 충전 가상계좌가 발급되었습니다.' : '가상계좌가 발급되었습니다.' }}
      </p>
      <div class="table_list mt20" style="max-width: 480px; margin: 20px auto 0;">
        <table class="write text-sm">
          <colgroup>
            <col width="140" />
            <col width="*" />
          </colgroup>
          <tbody>
            <tr>
              <th>은행명</th>
              <td>{{ virtualAccount.bankName }}</td>
            </tr>
            <tr>
              <th>계좌번호</th>
              <td>{{ virtualAccount.accountNumber }}</td>
            </tr>
            <tr>
              <th>예금주</th>
              <td>{{ virtualAccount.customerName }}</td>
            </tr>
            <tr>
              <th>입금 기한</th>
              <td>{{ formatDueDate(virtualAccount.dueDate) }}</td>
            </tr>
            <tr>
              <th>입금 금액</th>
              <td><strong style="color: #78420c;">{{ formatPrice(virtualAccount.amount) }}</strong> 원</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p class="mt20" style="color: #888; font-size: 13px;">
        * 입금 기한 내 입금하지 않으면 자동 취소됩니다.
      </p>
      <button v-if="paymentType === 'DR'" class="btn btn_md btn_brown mt20" @click="$router.push('/mypage/depositList')">
        적립금 내역으로 이동
      </button>
      <button v-else class="btn btn_md btn_brown mt20" @click="$router.push('/mypage/PrescriptionList')">
        처방 내역으로 이동
      </button>
    </div>
    <div v-else>
      <p class="font_orange" style="font-size: 18px;">결제 처리 중 오류가 발생했습니다.</p>
      <p>{{ errorMessage }}</p>
      <button class="btn btn_md btn_deepbrown mt20" @click="$router.push('/mypage/PrescriptionList')">
        확인
      </button>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'TossPaymentResult',
  data() {
    return {
      status: 'loading',
      errorMessage: '',
      virtualAccount: null,
      paymentType: '',
    }
  },
  async created() {

    const { paymentKey, orderId, amount } = this.$route.query

    console.log("@@@@ paymentKey : %o",paymentKey);

    if (!paymentKey || !orderId || !amount) {
      this.$router.replace('/mypage/PrescriptionList')
      return
    }

    const pending = JSON.parse(sessionStorage.getItem('toss_pending_payment') || '{}')
    sessionStorage.removeItem('toss_pending_payment')

    this.paymentType = pending.paymentType || ''

    try {
      let res

      // 적립금 가상계좌 요청 처리
      if (pending.paymentType === 'DR') {
        res = await axios.post('/api/user/mypage/tossDepositRequestConfirm', {
          paymentKey,
          orderId,
          amount: Number(amount),
          clinic_doctor_id: pending.clinic_doctor_id,
          phone: pending.phone,
        })
      } else {
        res = await axios.post('/api/user/mypage/tossPaymentConfirm', {
          paymentKey,
          orderId,
          amount: Number(amount),
          paymentList: pending.paymentList,
          deposit_use_price: pending.deposit_use_price,
          point_use_price: pending.point_use_price,
          clinic_doctor_id: pending.clinic_doctor_id,
          paymentMethod: pending.paymentMethod,
        })
      }

      if (pending.paymentMethod === 'VB') {
        this.virtualAccount = res.data.virtualAccount
        this.status = 'virtual_account'
      } else {
        this.status = 'success'
      }
    } catch (err) {
      this.status = 'fail'
      this.errorMessage = (err.response && err.response.data && err.response.data.message) || '잠시 후 다시 시도해주세요.'
      console.error(err)
    }
  },
  methods: {
    formatPrice(val) {
      return Number(val).toLocaleString()
    },
    formatDueDate(dueDate) {
      if (!dueDate) return ''
      const d = new Date(dueDate)
      if (isNaN(d)) return dueDate
      const pad = (n) => String(n).padStart(2, '0')
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`
    },
  },
}
</script>